<template>
  <div>
    <div class="page-header">
      <div>
        <h2 class="main-content-title tx-24 mg-b-5">Admins</h2>
      </div>
      <div class="d-flex">
        <div class="justify-content-center">
          <router-link :to="'/admin/add'" type="button" class="btn btn-primary my-2 btn-icon-text">
            <i class="fe fe-plus-square mr-2"></i> Add Admin
          </router-link>
        </div>
      </div>
    </div>
    <div class="row row-sm">
      <div class="col-lg-12">
        <div class="card custom-card">
          <div class="card-body">
            <div>
              <h6 class="main-content-label mb-1">Info</h6>
            </div>
            <div class="table-responsive">
              <div class="section section-service-info">
                <div class="">
                  <div class="service-info">
                    <div class="service-info__preview">
                      <b-table striped hover :items="admins" :fields="tableFields">
                        <template #cell(admin_roles)="row">
                          <div v-if="row.item.admin_roles">
                            <p v-for="(role, i) in row.item.admin_roles" :key="i">{{role.name}}</p>
                          </div>
                        </template>
                        <template #cell(status)="row">
                          <span class="badge text-white" :class="{'bg-success': row.item.status === 'active', 'bg-danger': row.item.status !== 'active'}">{{row.item.status}}</span>
                        </template>
                        <template #cell(actions)="row">
                          <router-link :to="`/admin/${row.item.id}`" class="btn btn-outline-primary mr-2 mt-1 mb-1">
                            <i class="fe fe-edit"></i>
                          </router-link>
                          <button @click="restoreItem(row.item.id)" type="button" class="btn btn-outline-danger mr-2 mt-1 mb-1">
                            <i class="fe fe-trash-2"></i>
                          </button>
                        </template>
                      </b-table>
                      <div class="d-flex justify-content-end  mt-3">
                        <div class="mr-3">
                          <b-form-select
                            @change="changePaginationPerPage"
                            style="width: 80px"
                            v-model="paginationPerPage"
                            :options="paginationOptions"
                          >
                          </b-form-select>
                        </div>
                        <div>
                          <b-pagination
                            class="m-0"
                            @change="changePagination"
                            v-model="paginationCurrentPage"
                            :total-rows="pagination.count"
                            :per-page="paginationPerPage"
                            first-text="<<"
                            prev-text="<"
                            next-text=">"
                            last-text=">>"
                          ></b-pagination>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'News',
  data () {
    return {
      paginationOptions: [
        { value: 6, text: '6' },
        { value: 10, text: '10' },
        { value: 30, text: '30' },
        { value: 100, text: '100' }
      ],
      paginationCurrentPage: 1,
      paginationPerPage: 6,
      pagination: {},
      serviceList: []
    }
  },
  computed: {
    ...mapState({
      admins: state => state.admin.admins
    }),
    tableFields () {
      return [
        {
          key: 'id',
          label: 'Id',
          sortable: true
        },
        {
          key: 'name',
          label: 'Name',
          sortable: true
        },
        {
          key: 'email',
          label: 'Email',
          sortable: true
        },
        {
          label: 'Roles',
          key: 'admin_roles',
          sortable: false
        },
        {
          key: 'actions',
          sortable: false
        }
      ]
    }
  },
  created () {
    this.getList({})
  },
  methods: {
    ...mapActions({
      getAdminLists: 'admin/getAdminLists',
      deleteItem: 'admin/deleteItem'
    }),
    getList (page) {
      this.getAdminLists(page).then(res => {
        this.pagination = res.pagination
      }).catch(err => {
        if (err && err.response) {
          if (err.response.status === 422) {
            const data = err.response.data.errors
            const keys = Object.keys(data)
            const msg = data[keys[0]]
            this.$toasted.error(msg).goAway(1500)
          } else {
            this.$toasted.error(err.response.message).goAway(1500)
          }
        }
      })
    },
    changePaginationPerPage (value) {
      this.getList({ page: this.paginationCurrentPage, count: value })
    },
    changePagination (page) {
      this.getList({ page: page, count: this.paginationPerPage })
    },
    restoreItem (id) {
      this.deleteItem(id)
    }
  }
}
</script>
